<template lang="html">
  <div class="box-wrap">
    <div class="box">
      <div class="name">{{name}}</div>
      <img >
      <slot></slot>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    name: String
  },
  created() {
  },
  data() {
    return {
    }
  },
  methods: {
  }
}

</script>
 
<style lang="stylus" scoped>
.box-wrap {
  width: 100%;
}

.box {
  width: 100%;
  background: url('../../../../../../assets/img/helpPoor/listborder.png');
  background-size: 100% 100%;
}

.name {
  font-size: 20px;
  font-weight: 500;
  color: rgba(255, 255, 255, 1);
  line-height: 20px;
  padding: 10px;
}
</style>



// WEBPACK FOOTER //
// index.vue?5d32808b